import createReactComponent from '../createReactComponent';
export default createReactComponent('switch', 'IconSwitch', [
  ['path', { d: 'M15 4l4 0l0 4', key: 'svg-0' }],
  ['path', { d: 'M14.75 9.25l4.25 -5.25', key: 'svg-1' }],
  ['path', { d: 'M5 19l4 -4', key: 'svg-2' }],
  ['path', { d: 'M15 19l4 0l0 -4', key: 'svg-3' }],
  ['path', { d: 'M5 5l14 14', key: 'svg-4' }],
]);
